export const EDIT_AND_REWIND_HIGHLIGHT_DURATION_MS = 2000;
